import { useContext } from 'react';
import { SubAccountListContext, SubAccountListContextValue } from './SubAccountListContext';

export default function useSubAccountList(): SubAccountListContextValue {
  const value = useContext(SubAccountListContext);

  if (!value) {
    throw new Error(
      'useSubAccountList: used outside the Sub-Account List feature root. Only internal feature components may call it.',
    );
  }

  return value;
}
